import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  portrait: {},
  itemDetailsContainer: {
    // height: '100%',
    width: 360,
    position: 'relative',
    zIndex: 3,
    '&$portrait': {
      '@media (max-width: 1023px)': {
        width: 300
      },
      '@media (max-width: 767px)': {
        width: '100%',
        '& $detailsButton': {
          display: 'none'
        },
        '& $itemDescriptionTypography': {
          display: 'block',
          marginTop: theme.spacing(1.5),
          marginRight: theme.spacing(-1)
        },
        '& $detailsBox': {
          paddingBottom: theme.spacing(1.5)
        }
      }
    }
  },
  itemContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  itemTitleTypography: {
    marginBottom: theme.spacing(1),
    overflow: 'hidden'
  },
  itemDescriptionTypography: {
    display: 'none',
    height: 200,
    overflow: 'auto'
  },
  imageBox: {
    position: 'relative'
  },
  detailsButton: {
    position: 'absolute',
    bottom: theme.spacing(4),
    left: '50%',
    transform: 'translateX(-50%)',
    borderRadius: 20,
    color: theme.palette.secondary.main
  },
  detailsBox: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  headerImage: {
    width: '100%',
    verticalAlign: 'bottom'
  },
  retailValue: {
    marginBottom: theme.spacing(1),
    fontSize: '1rem'
  },
  closeButton: {
    position: 'fixed',
    bottom: theme.spacing(4),
    right: theme.spacing(4)
  },
  arrowIcon: {
    fontSize: 30,
    marginLeft: theme.spacing()
  },
  bidBoard: {
    position: 'absolute',
    top: 0
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/ItemDetails/styles.js